<template>
    <div class="sopDetail-module">
        <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
            <div class="main-box">
                <div class="content-box">
                    <div class="content-inner">
                        <div class="inner-title">{{ detail.name }}</div>
                        <div class="inner-box" v-for="item, index in detail.content" :key="index">
                            <!-- 文字 -->
                            <div class="inner-txt font28 mb-30" v-if="item.type == 1">{{ item.conents }}</div>
                            <!-- 2图片 -->
                            <div class="flex-col flex-y-center mb-30" v-if="item.type == 2">
                                <img class="inner-img" referrerpolicy="no-referrer" :src="item.imagePath" alt="" />
                                <div class="inner-txt font26">（{{ item.title }}）</div>
                            </div>
                            <!-- 3小程序 -->
                            <div class="flex-col flex-y-center mb-30" v-if="item.type == 3">
                                <div class="inner-prog flex-col flex-y-center flex-x-center">
                                    <div class="prog-card-top">
                                        <div class="flex-y-center">
                                            <div class="card-circle"></div>
                                            <div class="Black font24">{{ item.title }}</div>
                                        </div>
                                        <img class="card-img" referrerpolicy="no-referrer" :src="item.imagePath" alt="" />
                                    </div>
                                    <div class="prog-card-bottom"></div>
                                </div>
                            </div>
                            <!-- 4视频 -->
                            <div class="mb-30 flex-col flex-y-center" v-if="item.type == 4">
                                <video class="inner-img" :src="item.filePath" controls></video>
                            </div>
                            <!-- 5文件 -->
                            <div class="flex-y-center flex-start mb-30" v-if="item.type == 5" @click="viewFile(item.filePath)">
                                <img class="file-icon" referrerpolicy="no-referrer" :src="item.filePath" alt="" />
                                <div class="file-name">{{ item.title }}</div>
                                <div class="file-btn">点击查看</div>
                            </div>
                        </div>
                    </div>
                    <div class="content-bottom ">
                        <div>下发时间：{{ detailData.beginDate }}</div>
                        <div>截止时间：{{ detailData.endDate }}</div>
                        <div>已完成人数：{{ detailData.schedule }}</div>
                    </div>
                </div>
                <div class="confirm-btn" v-if="detailData.status == 0" @click="confirm()">
                    确认
                </div>
                <div class="member-box">
                    <div class="member-title">
                        待确认成员
                    </div>
                    <div class="member-list flex flex-start">
                        <div class="member-item flex-col flex-y-center" v-for="item, index in unconfirmed" :key="index">
                            <img class="memeber-img" referrerpolicy="no-referrer" :src="item.avatar" alt="" />
                            <div class="memeber-txt">
                                {{ item.empName }}
                            </div>
                        </div>
                    </div>
                    <div class="member-title">
                        已确认成员
                    </div>
                    <div class="member-list flex flex-start">
                        <div class="member-item flex-col flex-y-center" v-for="item, index in notarize" :key="index">
                            <img class="memeber-img" referrerpolicy="no-referrer" :src="item.avatar" alt="" />
                            <div class="memeber-txt">
                                {{ item.empName }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-pull-refresh>

    </div>
</template>

<script>
    import request from "@/utils/request";
    import { Toast } from 'vant'

    export default {
        name: 'sopDetail',
        components: {
        },
        data() {
            return {
                refreshing: false,
                detailData: {},//外层数据
                detail: [],// 规则内容
                notarize: {},//已确认成员列表
                unconfirmed: {},//待确认成员列表
            }
        },
        computed: {
        },
        mounted() {
            this.getSopDetail();
        },
        methods: {
            // 获取列表
            getSopDetail() {
                request({
                    url: "/workContactSop/info?id=" + this.$route.query.id,
                    method: "get",
                })
                    .then((res) => {
                        this.detailData = res.data
                        this.detail = res.data.detail
                        this.notarize = res.data.notarize
                        this.unconfirmed = res.data.unconfirmed
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            onRefresh() {
                this.refreshing = false
                this.getSopDetail()
            },
            // 确认
            confirm() {
                request({
                    url: `/workContactSop/status/${this.$route.query.id}`,
                    method: "put",
                })
                    .then((res) => {
                        if (res.code == 0) {
                            this.onRefresh()
                            Toast({ position: 'top', message: '确认成功' })
                        }
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            //打开文件
            viewFile(filePath) {
                this.$router.push({ name: "viewfile", query: { url: filePath } });
            }

        },
    }
</script>

<style scoped lang="less">
    .ml-20 {
        margin-left: 20px;
    }

    .content-inner::-webkit-scrollbar {
        display: block !important;
        width: 10px;
    }

    .content-inner::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/

        width: 10px;
        height: 471px;
        background: #a6a6a6;
        border-radius: 8px;
    }

    .sopDetail-module {
        height: 100%;
        background-color: #ffffff;
        overflow-y: auto;
    }

    .main-box {
        padding: 40px 30px;

        .content-box {
            width: 690px;
            height: 906px;
            background: #fafafe;
            margin-bottom: 50px;
        }

        .content-inner {
            max-height: 685px;
            border-bottom: 1px solid #d7d7d7;
            overflow-y: scroll;
            padding: 30px;

            .inner-title {
                width: 170px;
                height: 48px;
                font-size: 34px;
                font-weight: 700;
                color: #35434c;
                line-height: 48px;
                margin-bottom: 20px;
            }

            .inner-txt {
                font-weight: 400;
                color: #35434c;
            }

            .inner-img {
                width: 530px;
                height: 328px;
                margin-bottom: 20px;
            }

            .inner-prog {
                width: 530px;
                min-height: 415px;
                background: #f3f3f3;

                .prog-card-top {
                    width: 350px;
                    min-height: 336px;
                    background: #ffffff;
                    padding: 20px 21px 0 21px;

                    .card-circle {
                        width: 10px;
                        height: 10px;
                        background: #2fd0d5;
                        border-radius: 50%;
                        margin-right: 11px;
                    }

                    .card-img {
                        width: 313px;
                        height: 255px;
                        margin-top: 10px;
                    }
                }

                .prog-card-bottom {
                    width: 350px;
                    height: 38px;
                    border-top: 1px solid #d7d7d7;
                    background-color: #fff;
                }
            }

            .file-icon {
                width: 34px;
                height: 34px;
                margin-right: 10px;
            }

            .file-name {
                font-size: 24px;
                color: #4375c9;
                margin-right: 30px;
            }

            .file-btn {
                width: 100px;
                height: 30px;
                background: #2fd0d5;
                border-radius: 18px;
                color: #fff;
                font-size: 20px;
                text-align: center;
            }
        }

        .content-bottom {
            height: 220px;
            padding: 30px;
            font-size: 28px;
            color: #35434c;

            div {
                margin-bottom: 20px;
            }
        }

        .confirm-btn {
            margin: 0 auto;
            width: 630px;
            height: 88px;
            line-height: 88px;
            background: #333f48;
            border-radius: 44px;
            text-align: center;
            font-size: 32px;
            color: #ffffff;
            margin-bottom: 50px;
        }

        .member-box {
            margin-bottom: 78px;

            .member-title {
                font-size: 34px;
                font-weight: 700;
                color: #35434c;
                line-height: 48px;
                margin-bottom: 40px;
            }

            .member-list {
                flex-wrap: wrap;
            }

            .member-item {
                margin-right: 30px;
                margin-bottom: 40px;
            }

            .memeber-img {
                width: 80px;
                height: 80px;
                border-radius: 50%;
                margin-bottom: 16px;
            }

            .memeber-txt {
                font-size: 28px;
                font-weight: 700;
                color: #35434c;
            }
        }
    }
</style>
